module.exports = __webpack_public_path__ + "static/media/partners.a4f3e475.png";